import { IonButton, IonIcon, IonRouterLink } from '@ionic/react';
import React, { useCallback } from 'react';

import { ButtonContainer, Spacer } from '@/components/common';
import Selection from '@/components/selection/Selection';
import { useLanguage } from '@/contexts/LanguageContext';
import { useScheduleFlow } from '@/contexts/ScheduleFlowContext';
import { useToast } from '@/hooks';
import { SCHEDULE_FLOW_STEPS } from '@/utils/constants';
import { arrowForwardCircleOutline } from 'ionicons/icons';
import moment from 'moment';

import './SelectTime.css';

const SelectTime: React.FC = () => {
  const { t } = useLanguage();
  const {
    selectedDate,
    availableTimeslots,
    selectedTime,
    setSelectedTime,
    setCurrentStep
  } = useScheduleFlow();

  const displayToast = useToast();
  const copy = {
    subHeader: t('schedule.selectTime.subHeader'),
    header: t('schedule.selectTime.header'),
    buttonText: t('schedule.selectTime.buttonText'),
    changeDateText: t('schedule.selectTime.changeDateText')
  };

  const onNext = () => {
    if (selectedTime) {
      setCurrentStep(SCHEDULE_FLOW_STEPS.SIGN_UP);
    } else {
      displayToast({
        message: t('schedule.selectTime.errorMessage'),
        duration: 2400,
        position: 'bottom',
        positionAnchor: 'nextButton'
      });
    }
  };

  const onChangeDate = () => {
    setCurrentStep(SCHEDULE_FLOW_STEPS.SELECT_DATE);
  };

  const getLabel = (time: string) => {
    return moment(time, 'HH:mm').format('h:mm A');
  };

  const isSelected = (time: string) => {
    return time === selectedTime;
  };

  return (
    <div className="select-time">
      <Spacer top={32} bottom={16}>
        <h4 className="select-time__sub-header">{copy.subHeader}</h4>
        <h1 className="select-time__header">{copy.header}</h1>
      </Spacer>
      <div className="select-time__date">
        <h2 className="select-time__selected-date">
          {moment(selectedDate || new Date()).format('dddd, MMMM Do YYYY')}
        </h2>
        <IonRouterLink
          onClick={onChangeDate}
          className="select-time__change-date"
        >
          {copy.changeDateText}
        </IonRouterLink>
      </div>
      <Spacer top={16} bottom={102}>
        <Selection
          options={availableTimeslots}
          getLabel={getLabel}
          onClick={setSelectedTime}
          isSelected={isSelected}
        />
      </Spacer>
      <ButtonContainer>
        <IonButton
          className="select-time__next-button"
          onClick={onNext}
          expand="block"
          fill="solid"
          size="default"
          strong
        >
          <IonIcon slot="start" icon={arrowForwardCircleOutline}></IonIcon>
          {copy.buttonText}
        </IonButton>
      </ButtonContainer>
    </div>
  );
};

export default SelectTime;
